import { render, staticRenderFns } from "./footerPhone.vue?vue&type=template&id=dcefe4fc&scoped=true&"
import script from "./footerPhone.vue?vue&type=script&lang=js&"
export * from "./footerPhone.vue?vue&type=script&lang=js&"
import style0 from "./footerPhone.vue?vue&type=style&index=0&id=dcefe4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcefe4fc",
  null
  
)

export default component.exports